export const parseValue = (value: any) => {
    return value === '' ? null : value;
};
